var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-10 text-center"},[_vm._v(" "+_vm._s(_vm.$t('update.step3description'))+" ")]),_c('div',[_c('img',{staticClass:"update_finish",attrs:{"src":_vm.Updatefertig,"alt":"Update_Fertig"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }